// Copy for the review UI (product pages, the forScore / MobileSheets review
// strips) and for the stand-alone pay-link page, in all 7 site languages.

var reviewText = {
  en: {
    generalLabel: 'All {app} indexed files',
    heading: 'Customer Reviews',
    one: 'review',
    many: 'reviews',
    reviewFor: 'Review for',
    writeTitle: 'Write a Review',
    writeSubtitle: 'Share your experience with {name}',
    rating: 'Your Rating',
    name: 'Your Name',
    email: 'Your Email',
    emailNote: 'Your email will not be displayed publicly',
    text: 'Your Review',
    namePh: 'Enter your name',
    emailPh: 'Enter your email',
    textPh: 'Share your thoughts…',
    submit: 'Submit Review',
    submitting: 'Submitting…',
    thanks: 'Thank you! Your review has been sent and appears once approved.',
    errName: 'Please fill in your name and review',
    errEmail: 'Please enter your email address',
    errFail: 'Could not send your review. Please try again.',
    stripKicker: 'What players say',
    stripEmpty: 'Be the first to review the indexed files',
    stripWrite: 'Write a review',
    stripSeeAll: 'Read all reviews',
    stripHide: 'Hide reviews',
    generalTitle: 'Review the indexed files',
    generalSubtitle: 'One review covers the whole collection — no need to pick a single volume.',
    familyNote: 'Reviews are shared across every key of this title.',
    reply: 'Reply from Isaías'
  },
  es: {
    generalLabel: 'Todos los archivos indexados de {app}',
    heading: 'Opiniones de clientes',
    one: 'opinión',
    many: 'opiniones',
    reviewFor: 'Opinión sobre',
    writeTitle: 'Escribe una opinión',
    writeSubtitle: 'Comparte tu experiencia con {name}',
    rating: 'Tu valoración',
    name: 'Tu nombre',
    email: 'Tu correo',
    emailNote: 'Tu correo no se mostrará públicamente',
    text: 'Tu opinión',
    namePh: 'Escribe tu nombre',
    emailPh: 'Escribe tu correo',
    textPh: 'Cuéntanos qué te pareció…',
    submit: 'Enviar opinión',
    submitting: 'Enviando…',
    thanks: '¡Gracias! Tu opinión se envió y aparecerá en cuanto se apruebe.',
    errName: 'Completa tu nombre y tu opinión',
    errEmail: 'Escribe tu dirección de correo',
    errFail: 'No se pudo enviar tu opinión. Inténtalo de nuevo.',
    stripKicker: 'Lo que dicen los músicos',
    stripEmpty: 'Sé el primero en opinar sobre los archivos indexados',
    stripWrite: 'Escribir una opinión',
    stripSeeAll: 'Ver todas las opiniones',
    stripHide: 'Ocultar opiniones',
    generalTitle: 'Opina sobre los archivos indexados',
    generalSubtitle: 'Una sola opinión cubre toda la colección: no hace falta elegir un volumen.',
    familyNote: 'Las opiniones se comparten entre todas las tonalidades de este título.',
    reply: 'Respuesta de Isaías'
  },
  ja: {
    generalLabel: '{app} のインデックス済みファイル全体',
    heading: 'カスタマーレビュー',
    one: '件のレビュー',
    many: '件のレビュー',
    reviewFor: 'レビュー対象',
    writeTitle: 'レビューを書く',
    writeSubtitle: '{name} の感想をお寄せください',
    rating: '評価',
    name: 'お名前',
    email: 'メールアドレス',
    emailNote: 'メールアドレスは公開されません',
    text: 'レビュー',
    namePh: 'お名前を入力',
    emailPh: 'メールアドレスを入力',
    textPh: 'ご感想をお書きください…',
    submit: 'レビューを送信',
    submitting: '送信中…',
    thanks: 'ありがとうございます！レビューを受け付けました。承認後に表示されます。',
    errName: 'お名前とレビューを入力してください',
    errEmail: 'メールアドレスを入力してください',
    errFail: 'レビューを送信できませんでした。もう一度お試しください。',
    stripKicker: '演奏者の声',
    stripEmpty: 'インデックス済みファイルの最初のレビューを書いてみませんか',
    stripWrite: 'レビューを書く',
    stripSeeAll: 'すべてのレビューを読む',
    stripHide: 'レビューを閉じる',
    generalTitle: 'インデックス済みファイルのレビュー',
    generalSubtitle: '1件のレビューでコレクション全体をカバーできます。巻を選ぶ必要はありません。',
    familyNote: 'レビューはこのタイトルのすべての調で共有されます。',
    reply: 'Isaías からの返信'
  },
  de: {
    generalLabel: 'Alle indexierten {app}-Dateien',
    heading: 'Kundenbewertungen',
    one: 'Bewertung',
    many: 'Bewertungen',
    reviewFor: 'Bewertung zu',
    writeTitle: 'Bewertung schreiben',
    writeSubtitle: 'Teile deine Erfahrung mit {name}',
    rating: 'Deine Bewertung',
    name: 'Dein Name',
    email: 'Deine E-Mail',
    emailNote: 'Deine E-Mail wird nicht öffentlich angezeigt',
    text: 'Deine Bewertung',
    namePh: 'Name eingeben',
    emailPh: 'E-Mail eingeben',
    textPh: 'Schreibe deine Eindrücke…',
    submit: 'Bewertung senden',
    submitting: 'Wird gesendet…',
    thanks: 'Danke! Deine Bewertung ist eingegangen und erscheint nach der Freigabe.',
    errName: 'Bitte Name und Bewertung ausfüllen',
    errEmail: 'Bitte E-Mail-Adresse eingeben',
    errFail: 'Bewertung konnte nicht gesendet werden. Bitte erneut versuchen.',
    stripKicker: 'Das sagen Musiker',
    stripEmpty: 'Schreibe die erste Bewertung zu den indexierten Dateien',
    stripWrite: 'Bewertung schreiben',
    stripSeeAll: 'Alle Bewertungen lesen',
    stripHide: 'Bewertungen ausblenden',
    generalTitle: 'Die indexierten Dateien bewerten',
    generalSubtitle: 'Eine Bewertung gilt für die ganze Sammlung — kein einzelner Band nötig.',
    familyNote: 'Bewertungen gelten für alle Tonarten dieses Titels.',
    reply: 'Antwort von Isaías'
  },
  fr: {
    generalLabel: 'Tous les fichiers indexés {app}',
    heading: 'Avis clients',
    one: 'avis',
    many: 'avis',
    reviewFor: 'Avis sur',
    writeTitle: 'Laisser un avis',
    writeSubtitle: 'Partagez votre expérience avec {name}',
    rating: 'Votre note',
    name: 'Votre nom',
    email: 'Votre e-mail',
    emailNote: 'Votre e-mail ne sera pas affiché publiquement',
    text: 'Votre avis',
    namePh: 'Entrez votre nom',
    emailPh: 'Entrez votre e-mail',
    textPh: 'Dites-nous ce que vous en pensez…',
    submit: 'Envoyer l’avis',
    submitting: 'Envoi…',
    thanks: 'Merci ! Votre avis a été envoyé et apparaîtra après validation.',
    errName: 'Merci d’indiquer votre nom et votre avis',
    errEmail: 'Merci d’indiquer votre adresse e-mail',
    errFail: 'Impossible d’envoyer votre avis. Veuillez réessayer.',
    stripKicker: 'Ce que disent les musiciens',
    stripEmpty: 'Soyez le premier à donner votre avis sur les fichiers indexés',
    stripWrite: 'Laisser un avis',
    stripSeeAll: 'Lire tous les avis',
    stripHide: 'Masquer les avis',
    generalTitle: 'Donnez votre avis sur les fichiers indexés',
    generalSubtitle: 'Un seul avis couvre toute la collection — inutile de choisir un volume.',
    familyNote: 'Les avis sont partagés entre toutes les tonalités de ce titre.',
    reply: 'Réponse d’Isaías'
  },
  it: {
    generalLabel: 'Tutti i file indicizzati {app}',
    heading: 'Recensioni dei clienti',
    one: 'recensione',
    many: 'recensioni',
    reviewFor: 'Recensione di',
    writeTitle: 'Scrivi una recensione',
    writeSubtitle: 'Racconta la tua esperienza con {name}',
    rating: 'La tua valutazione',
    name: 'Il tuo nome',
    email: 'La tua email',
    emailNote: 'La tua email non sarà mostrata pubblicamente',
    text: 'La tua recensione',
    namePh: 'Inserisci il tuo nome',
    emailPh: 'Inserisci la tua email',
    textPh: 'Raccontaci cosa ne pensi…',
    submit: 'Invia recensione',
    submitting: 'Invio…',
    thanks: 'Grazie! La tua recensione è stata inviata e apparirà dopo l’approvazione.',
    errName: 'Inserisci nome e recensione',
    errEmail: 'Inserisci il tuo indirizzo email',
    errFail: 'Non è stato possibile inviare la recensione. Riprova.',
    stripKicker: 'Cosa dicono i musicisti',
    stripEmpty: 'Scrivi la prima recensione sui file indicizzati',
    stripWrite: 'Scrivi una recensione',
    stripSeeAll: 'Leggi tutte le recensioni',
    stripHide: 'Nascondi le recensioni',
    generalTitle: 'Recensisci i file indicizzati',
    generalSubtitle: 'Una recensione vale per tutta la collezione — non serve scegliere un volume.',
    familyNote: 'Le recensioni sono condivise tra tutte le tonalità di questo titolo.',
    reply: 'Risposta di Isaías'
  },
  uk: {
    generalLabel: 'Усі індексовані файли {app}',
    heading: 'Відгуки клієнтів',
    one: 'відгук',
    many: 'відгуків',
    reviewFor: 'Відгук про',
    writeTitle: 'Написати відгук',
    writeSubtitle: 'Поділіться досвідом про {name}',
    rating: 'Ваша оцінка',
    name: 'Ваше ім’я',
    email: 'Ваш email',
    emailNote: 'Ваш email не буде показано публічно',
    text: 'Ваш відгук',
    namePh: 'Введіть ім’я',
    emailPh: 'Введіть email',
    textPh: 'Розкажіть про свої враження…',
    submit: 'Надіслати відгук',
    submitting: 'Надсилання…',
    thanks: 'Дякуємо! Відгук надіслано — він з’явиться після перевірки.',
    errName: 'Вкажіть ім’я та текст відгуку',
    errEmail: 'Вкажіть вашу email-адресу',
    errFail: 'Не вдалося надіслати відгук. Спробуйте ще раз.',
    stripKicker: 'Що кажуть музиканти',
    stripEmpty: 'Станьте першим, хто залишить відгук про індексовані файли',
    stripWrite: 'Написати відгук',
    stripSeeAll: 'Читати всі відгуки',
    stripHide: 'Сховати відгуки',
    generalTitle: 'Відгук про індексовані файли',
    generalSubtitle: 'Один відгук охоплює всю колекцію — не потрібно обирати том.',
    familyNote: 'Відгуки спільні для всіх тональностей цього видання.',
    reply: 'Відповідь Isaías'
  }
};

export default reviewText;
